import { ACTION_PERMISSION_MAP, HYDRAULICS_ADMIN_ROLES, USER_TYPE } from './constants';

export const checkPermissions = (
  actionType,
  permissions
) => {
  if (!permissions) return false;

  const permissionKey = ACTION_PERMISSION_MAP[actionType];

  if (!permissionKey) return false;

  return Boolean(
    permissions[permissionKey]
  );
};

export const checkWritePermissionsDisabled = (permissions) => {
  if (!permissions) return false;
  return Object.entries(permissions)
    .filter(([key]) => key !== 'read')
    .every(([, value]) => value === false);
};

export const checkHydraulicsAdmin = (userType, accessLevels = []) => {
  if (HYDRAULICS_ADMIN_ROLES.includes(userType)) {
    return true;
  }

  if (userType === USER_TYPE.PREMIUM_SELECT_ADMIN) {
    return accessLevels.some(level =>
      HYDRAULICS_ADMIN_ROLES.includes(level)
    );
  }

  return false;
};
